export default __webpack_public_path__ + "static/clave-6e20b712f41902a7422d0d882d752956.webp";